function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
import { mixpanel, ga } from '@domain-group/fe-co-allhomes-analytics';
import { SeparatorMenuItem } from '../components/menu';
import primaryNav from '../menu';
import { GAActions, GALabels } from './constants';
var SearchTypeMap = {
  SCHOOL: GALabels.SCHOOL_SEARCH,
  DEVELOPMENT: GALabels.PROJECT_SEARCH,
  ADDRESS: GALabels.ADDRESS_SEARCH
};
var additionalData = {
  version: 'new'
};
var buildEvents = _ref => {
  var gaAction = _ref.gaAction,
    mixpanelEvent = _ref.mixpanelEvent,
    events = _ref.events;
  return Object.fromEntries(Object.entries(events).map(_ref2 => {
    var _ref3 = _slicedToArray(_ref2, 2),
      key = _ref3[0],
      label = _ref3[1];
    return [key, () => [...(gaAction ? [ga.interaction(gaAction, label)] : []), ...(mixpanelEvent ? [mixpanelEvent(_objectSpread({
      interactionCTA: label
    }, additionalData))] : [])]];
  }));
};
var signInUpEvents = {
  'header.sign-in': 'Sign In - Header',
  'header.sign-up': 'Sign Up - Header',
  'header.sign-out': 'Log Out - Header',
  'nav.sign-in': 'Sign In - Hamburger menu',
  'nav.sign-up': 'Sign Up - Hamburger menu',
  'nav.sign-out': 'Log Out - Hamburger menu'
};
var mapMenuItem = menuItem => {
  if (menuItem === SeparatorMenuItem) {
    return [];
  }
  var thisItem = [menuItem.id, menuItem.analyticsEventName || menuItem.label];
  var children = 'items' in menuItem ? menuItem.items.map(subMenuItem => subMenuItem === SeparatorMenuItem ? subMenuItem : _objectSpread(_objectSpread({}, subMenuItem), {}, {
    label: subMenuItem.analyticsEventName || "".concat(menuItem.label, " - ").concat(subMenuItem.label)
  })).flatMap(mapMenuItem) : [];
  return [thisItem, ...children];
};
var primaryNavMap = Object.fromEntries(primaryNav.flatMap(menuGroup => menuGroup.flatMap(mapMenuItem)));
var eventMapper = _objectSpread(_objectSpread({
  'load-nav': () => mixpanel.displayTopNav(additionalData),
  'load-myah': () => mixpanel.displayMyAhNav(additionalData),
  '/(header|nav)\\.menu-item-click$/': (key, data) => data.item.id ? [ga.interaction(GAActions.PRIMARY_NAV, primaryNavMap[data.item.id]), mixpanel.clickTopNav(_objectSpread(_objectSpread({}, additionalData), {}, {
    interactionCTA: primaryNavMap[data.item.id]
  }))] : [],
  '/myah\\.menu-item-click/': (key, _ref4) => {
    var item = _ref4.item;
    return item.label ? [mixpanel.clickMyAhNav(_objectSpread(_objectSpread({}, additionalData), {}, {
      interactionCTA: item.label
    }))] : [];
  }
}, buildEvents({
  gaAction: GAActions.PRIMARY_NAV,
  mixpanelEvent: mixpanel.clickSignInUp,
  events: signInUpEvents
})), {}, {
  '/autocomplete-search/': (key, _ref5) => {
    var items = _ref5.items;
    var label = items.length > 0 && SearchTypeMap[items[0].type];
    return label ? ga.typeahead(GAActions.MOBILE_HEADER, label) : null;
  }
});
export default eventMapper;